function init() {
    var Layout = require('views/_Layout');
    this.layout = new Layout();
    this.layout.render();

    $('#cotacao-appviewbox').append(this.layout.$el);

    // this.layout.triggerMethod('attach');
}

module.exports = init;



// WEBPACK FOOTER //
// ./resources/scripts/views/init.js